import { useCallback, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

import { FastUWRejection } from "@covertree/new-business-fast-uw-rejection";
import { CountyBlockerErrorType, RedZoneErrorType } from "@covertree/types";

import formatPageTitle from "@utils/formatPageTitle";

import { useResetNewPolicy } from "@hooks/newPolicy";
import { NewPolicyRoutes } from "@routing/paths";

export function FastUWStep() {
  const location = useLocation();

  const resetNewPolicy = useResetNewPolicy();

  const state = location.state as
    | {
        errorType?: RedZoneErrorType | CountyBlockerErrorType;
        errorMessage?: string;
      }
    | undefined;

  const onCreateNewQuote = useCallback(() => {
    resetNewPolicy(NewPolicyRoutes.SELECT_PRODUCT);
  }, [resetNewPolicy]);

  useEffect(() => {
    if (!state?.errorType) {
      resetNewPolicy(NewPolicyRoutes.SELECT_PRODUCT);
    }
  }, [state?.errorType, resetNewPolicy]);

  if (!state?.errorType) {
    return null;
  }

  return (
    <>
      <Helmet>
        <title>{formatPageTitle("Risk is too high")}</title>
      </Helmet>
      <FastUWRejection
        icon={"/images/decline-property/decline-property.webp"}
        onCreateNewQuote={onCreateNewQuote}
        errorType={state.errorType}
        errorMessage={state.errorMessage}
        showLegalText
      />
    </>
  );
}
